import * as yup from "yup";

import { Toast } from "@app/common/hooks/useToasts";
import { isResponseErrorWithStatus } from "@app/common/utils";

// Match at least one non-alphanumeric character
export const PASSWORD_REGEX = /.*[^a-z0-9]+.*/i;

export const getRequiredMessage = (field: any) => {
  const label =
    field.label || field.path.replace(/([A-Z])/g, " $1").toLowerCase();

  if (label.match(/^[aeiou]/)) {
    return `Please enter an ${label}`;
  }
  return `Please enter a ${label}`;
};

export const requiredWhenEmail = (action: string, schema: yup.StringSchema) => {
  return action === "email"
    ? schema.required(getRequiredMessage)
    : schema.notRequired();
};

export const isDomainError = async (error: unknown) => {
  if (isResponseErrorWithStatus(error, 403)) {
    const body = await error.response.json();
    if (body.detail.includes("not permitted by workspace")) {
      return true;
    }
  }
  return false;
};

export const DOMAIN_ERROR_TOAST: Toast = {
  title: "Could not create account",
  message:
    "The administrator of this domain has restricted account creation. Contact your administrator to request a Read Workspace invitation, or create an account with a different domain.",
  type: "system",
  severity: "error",
  dismissible: true,
  sticky: true,
  anchorOrigin: {
    vertical: "top",
    horizontal: "right",
  },
};

export const DUPLICATE_ACCOUNT_TOAST: Toast = {
  title: "Could not create account",
  message:
    "There is already an account for this email address. Please sign in or create an account with a different email address.",
  type: "system",
  severity: "error",
  dismissible: true,
  sticky: true,
  anchorOrigin: {
    vertical: "top",
    horizontal: "right",
  },
};
